document.addEventListener('DOMContentLoaded', function() {
  // Existing DOM elements
  const searchForm = document.querySelector('.search-page__form');
  const searchInput = document.querySelector('.search-page__input');
  const loadMoreButton = document.querySelector('.search-page__load-more');
  const productsGrid = document.querySelector('.search-page__products-section .search-page__grid');
  const pagesGrid = document.querySelector('.search-page__pages-section .search-page__grid');
  const storiesGrid = document.querySelector('.search-page__stories-section .search-page__grid');
  const loadingElement = document.querySelector('.search-page__loading');
  const paginationLinks = document.querySelector('.search-page__pagination-links');
  
  // New elements for editable search term
  const searchTermSpan = document.getElementById('searchEditableTerm');
  const searchEditableInput = document.getElementById('searchEditableInput');
  
  // Storefront API settings
  const STOREFRONT_ACCESS_TOKEN = '76249782dd572514a4ca845b94d77d7d';
  const SHOP_DOMAIN = window.Shopify?.shop || window.location.hostname;
  
  // Current search state
  let currentPage = 1;
  let currentSearchTerm = new URLSearchParams(window.location.search).get('q') || '';
  let isLoading = false;
  let hasMoreResults = document.querySelector('.search-page__pagination') !== null;
  let storyHandles = new Set(); // To track which pages are stories
  
  // Hide standard pagination links if JS is available
  if (paginationLinks) {
    paginationLinks.style.display = 'none';
  }
  
  // Initialize editable search term functionality
  if (searchTermSpan && searchEditableInput) {
    // Make search term clickable to edit
    searchTermSpan.addEventListener('click', function() {
      makeSearchTermEditable();
    });
    
    // Handle keyboard navigation for accessibility
    searchTermSpan.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        makeSearchTermEditable();
      }
    });
    
    // Handle input blur events
    searchEditableInput.addEventListener('blur', function() {
      finishEditing();
    });
    
    // Handle input keydown events
    searchEditableInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        finishEditing();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        cancelEditing();
      }
    });
  }
  
  // Function to make the search term editable
  function makeSearchTermEditable() {
    searchTermSpan.classList.add('hidden');
    searchEditableInput.classList.add('active');
    searchEditableInput.focus();
    // Select all text in the input
    searchEditableInput.setSelectionRange(0, searchEditableInput.value.length);
  }
  
  // Function to finish editing and perform search
  function finishEditing() {
    const newSearchTerm = searchEditableInput.value.trim();
    
    // If search term is empty or unchanged, just cancel editing
    if (newSearchTerm === '' || newSearchTerm === currentSearchTerm) {
      cancelEditing();
      return;
    }
    
    // Update the search term
    searchTermSpan.textContent = newSearchTerm;
    searchEditableInput.classList.remove('active');
    searchTermSpan.classList.remove('hidden');
    
    // Update URL without reloading the page
    const newUrl = updateUrlParameter(window.location.href, 'q', newSearchTerm);
    window.history.pushState({ path: newUrl }, '', newUrl);
    
    // Update current search term and reset page
    currentSearchTerm = newSearchTerm;
    currentPage = 1;
    
    // Perform the search
    performSearchWithoutReload(newSearchTerm);
  }
  
  // Function to cancel editing without changes
  function cancelEditing() {
    searchEditableInput.value = currentSearchTerm;
    searchEditableInput.classList.remove('active');
    searchTermSpan.classList.remove('hidden');
  }
  
  // Function to update URL parameters without reloading the page
  function updateUrlParameter(url, key, value) {
    const urlObj = new URL(url);
    urlObj.searchParams.set(key, value);
    return urlObj.toString();
  }
  
  // Function to perform search without page reload
  async function performSearchWithoutReload(term) {
    showLoading();
    
    // Reset containers for new search
    if (productsGrid) productsGrid.innerHTML = '';
    if (pagesGrid) pagesGrid.innerHTML = '';
    if (storiesGrid) storiesGrid.innerHTML = '';
    
    // Hide sections until we have results
    const productsSection = document.querySelector('.search-page__products-section');
    const pagesSection = document.querySelector('.search-page__pages-section');
    const storiesSection = document.querySelector('.search-page__stories-section');
    
    if (productsSection) productsSection.style.display = 'none';
    if (pagesSection) pagesSection.style.display = 'none';
    if (storiesSection) storiesSection.style.display = 'none';
    
    try {
      // Search for products using Shopify's predictive search API
      const productResults = await searchProducts(term);
      
      // Search for stories using Storefront API
      const stories = await searchStories(term);
      
      // Update search results count in title
      const resultsCount = productResults.length + stories.length;
      const resultCountElement = document.querySelector('.search-page__title');
      if (resultCountElement) {
        resultCountElement.innerHTML = resultCountElement.innerHTML.replace(
          /Found \d+ results/,
          `Found ${resultsCount} results`
        );
      }
      
      // Show "No results" or render results
      if (resultsCount === 0) {
        // Redirect to the "no results" page
        window.location.href = `/search?q=${encodeURIComponent(term)}`;
        return;
      }
      
      // Render product results
      if (productResults.length > 0 && productsGrid) {
        // Show products section
        if (productsSection) productsSection.style.display = 'block';
        
        // Create a document fragment for better performance
        const fragment = document.createDocumentFragment();

        // console.log(productResults);
        
        // Add each product to the fragment
        productResults.forEach(product => {
          // const productCard = document.createElement('div');
          const productCard = createProductCard(product);
          // productCard.className = 'search-page__item search-page__product-item';
          // productCard.innerHTML = product.html;
          // console.log(product);
          fragment.appendChild(productCard);
        });
        
        // Add all products at once
        productsGrid.appendChild(fragment);
        
        // Initialize functionality on new items
        initializeProductCards();
      }
      
      // Render story results
      if (stories.length > 0) {
        storyHandles = new Set(stories.map(story => story.handle));
        
        // Show stories section
        if (storiesSection) {
          storiesSection.style.display = 'flex';
          
          // Clear existing stories
          if (storiesGrid) storiesGrid.innerHTML = '';
          
          // Add each story
          stories.forEach(story => {
            const storyCard = document.createElement('div');
            storyCard.className = 'search-page__item search-page__story-item';
            storyCard.setAttribute('data-handle', story.handle);
            storyCard.innerHTML = `
              <a href="${story.url}" class="story-card">
                <div class="story-card__image">
                  <img src="${story.featuredImage || '/assets/placeholder-story.jpg'}" alt="${story.title}" loading="lazy">
                </div>
                <div class="story-card__info">
                  <h3 class="story-card__title h4">${story.title}</h3>
                </div>
              </a>
            `;
            storiesGrid.appendChild(storyCard);
          });
        }
      }
      
      // Update load more button visibility
      hasMoreResults = productResults.length >= 18; // Assuming 18 is the page size
      if (loadMoreButton) {
        if (hasMoreResults) {
          loadMoreButton.classList.remove('hidden');
          // Move load more button to end of product grid
          moveLoadMoreButton();
        } else {
          loadMoreButton.classList.add('hidden');
        }
      }
      
      hideLoading();
    } catch (error) {
      console.error('Error during search:', error);
      hideLoading();
      
      // Fallback to traditional search on error
      window.location.href = `/search?q=${encodeURIComponent(term)}`;
    }
  }

  function createProductCard(product) {
    // Create main card element
    const cardElement = document.createElement('div');
    cardElement.className = `card-product search-results__product${product.type === "Opticals" ? " card-product--opticals" : ""}${product.type === "Watch" ? " card-product--watch" : ""}${product.type === "Jewelry" ? " card-product--jewelry" : ""}${product.tags.includes("coming-soon") ? " card-product--coming-soon" : ""}`;
    cardElement.setAttribute('data-product-card', '');
    
    // Product media
    const mediaLink = document.createElement('a');
    mediaLink.href = `/products/${product.handle}`;
    mediaLink.className = 'card-product__media';
    
    if (product.images && product.images.length > 0) {
      // Create gallery
      const gallery = document.createElement('div');
      gallery.className = 'card-product__gallery swiper';
      
      // First image section (featured image or shot on face)
      const firstImageContainer = document.createElement('div');
      firstImageContainer.className = 'card-product__gallery--first';
      
      const firstImg = document.createElement('img');
      // Use featured media or first image if media array not available
      const mediaSource = product.media && product.media.length > 0 ? 
                        product.media[0].src : 
                        product.featured_image?.src || product.images[0].src;

      // console.log('media source', mediaSource);
      
      firstImg.src = mediaSource;
      firstImg.alt = product.title;
      firstImg.className = 'card-product__gallery--first-image first-image--product';
      firstImg.loading = 'lazy';
      
      // Try to get shot_on_face metafield if available
      const shotOnFace = null;
      
      firstImageContainer.appendChild(firstImg);
      gallery.appendChild(firstImageContainer);
      
      // Create swiper wrapper for additional images
      const swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';
      
      // Skip first image if using shot_on_face
      const startIndex = shotOnFace ? 0 : 1;
      
      for (let i = startIndex; i < product.images.length; i++) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        
        const img = document.createElement('img');
        img.src = product.images[i].src || product.images[i];
        img.alt = product.title;
        img.className = 'card-product__image';
        
        // Add special class for second image if shot_on_face is used
        if (i === 1 && shotOnFace) {
          img.classList.add('card-product__image-second-contain');
        }
        
        img.loading = 'lazy';
        
        slide.appendChild(img);
        swiperWrapper.appendChild(slide);
      }
      
      gallery.appendChild(swiperWrapper);
      
      // Add pagination if multiple images
      if (product.images.length > 1) {
        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        gallery.appendChild(pagination);
      }
      
      mediaLink.appendChild(gallery);
    } else {
      // No media placeholder
      const noMedia = document.createElement('div');
      noMedia.className = 'card-product__no-media';
      noMedia.innerHTML = `<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.5-1.3-2.8-2.9-2.8zm.1 95.3H203.1v-92.5h121.6v92.5z"/><path d="M210.4 299.5H239c1.6 0 2.8-1.3 2.8-2.8v-59.9c0-1.6-1.3-2.8-2.8-2.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v59.9c0 1.5 1.3 2.8 2.8 2.8zm2.8-59.9h23v54.3h-23v-54.3zM309.1 236.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v28.6c0 1.6 1.3 2.8 2.8 2.8h28.6c1.6 0 2.8-1.3 2.8-2.8v-28.6c.1-1.6-1.2-2.8-2.8-2.8zm-2.7 28.6h-23v-23h23v23z"/></svg>`;
      mediaLink.appendChild(noMedia);
    }

    const badgeElement = createProductBadge(product);
    if (badgeElement) {
      mediaLink.appendChild(badgeElement);
    }
    
    // Favorite button with correct SVG
    const favorite = document.createElement('div');
    favorite.className = 'card-product__favorite';
    favorite.innerHTML = `
      <svg class="icon icon-heart" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M8 4.7905L7.29375 4.08425L6.53438 3.32488C5.92813 2.7155 5.10313 2.37488 4.24375 2.37488C2.45313 2.37488 1 3.828 1 5.61863C1 6.478 1.34063 7.303 1.95 7.91238L2.70625 8.66863L8 13.9624L13.2937 8.66863L14.05 7.91238C14.6594 7.303 15 6.478 15 5.61863C15 3.828 13.5469 2.37488 11.7563 2.37488C10.8969 2.37488 10.0719 2.7155 9.4625 3.32488L8.70625 4.08113L8 4.7905ZM8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="inherit"></path>
        <path class="icon-heart-fill-layer" d="M8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="none"></path>
      </svg>
    `;
    
    // Product info section
    const info = document.createElement('div');
    info.className = 'card-product__info';
    
    // Product title
    const title = document.createElement('a');
    title.href = `/products/${product.handle}`;
    title.className = 'card-product__title card-product__link';
    title.textContent = product.title;
    
    // Product price
    const priceContainer = document.createElement('div');
    priceContainer.className = 'card-product__price';
    
    const showPriceOnComingSoon = window.showComingSoonPrices || false;
    // console.log('showPriceOnComingSoon', showPriceOnComingSoon, window.showComingSoonPrices);
    const isComingSoon = product.tags?.includes('coming-soon');

    // Only add price if not opticals or coming soon with setting enabled
    if (isComingSoon) {
      if(showPriceOnComingSoon) {
        const priceInner = document.createElement('div');
        priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
        
        let priceHTML = '';
        
        // Add original price if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
          priceHTML += `<span class="visually-hidden">Regular price</span>`;
        }
        
        // Current price
        priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
        
        // Sale price label and savings if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="visually-hidden">Sale price</span>`;
          priceHTML += `<span class="price__savings">Save ${formatMoney(product.compare_at_price - product.price)}</span>`;
        }
        
        priceInner.innerHTML = priceHTML;
        priceContainer.appendChild(priceInner);
      }
    } else if (product.type !== "Opticals") {
      const priceInner = document.createElement('div');
      priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
      
      let priceHTML = '';
      
      // Add original price if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
        priceHTML += `<span class="visually-hidden">Regular price</span>`;
      }
      
      // Current price
      priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
      
      // Sale price label and savings if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="visually-hidden">Sale price</span>`;
        priceHTML += `<span class="price__savings">Save ${formatMoney(product.compare_at_price - product.price)}</span>`;
      }
      
      priceInner.innerHTML = priceHTML;
      priceContainer.appendChild(priceInner);
    }
    
    // Add elements to info container
    info.appendChild(title);
    info.appendChild(priceContainer);
    
    // Quick add button only for single-variant products
    if (product.available && !isComingSoon && product.type !== "Opticals" && product.variants?.length === 1) {
      const quickAdd = document.createElement('div');
      quickAdd.setAttribute('role', 'button');
      quickAdd.className = 'card-product__quick-add';
      quickAdd.setAttribute('data-quick-add', '');
      quickAdd.setAttribute('data-product-id', product.id);
      quickAdd.setAttribute('data-variant-id', product.variants[0].id);
      quickAdd.innerHTML = `
        <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
          <path class="icon-plus__horizontal" d="M7.42746 8.55261H1.14174H0.570312V9.69296H1.14174H7.42746H8.57031H14.856H15.4275V8.55261H14.856H8.57031H7.42746Z" fill="inherit"></path>
          <path class="icon-plus__vertical" d="M8.57031 8.55136L8.57031 2.26564L8.57031 1.69421L7.42996 1.69421L7.42996 2.26564L7.42996 8.55136L7.42996 9.69421L7.42996 15.9799L7.42996 16.5514L8.57031 16.5514L8.57031 15.9799L8.57031 9.69421L8.57031 8.55136Z" fill="inherit"></path>
        </svg>
      `;
      info.appendChild(quickAdd);
    }
    
    // Add all sections to card
    cardElement.appendChild(mediaLink);
    cardElement.appendChild(favorite);
    cardElement.appendChild(info);
    
    return cardElement;
  }

  function createProductBadge(product) {
    let badgeToShow = "";
    
    // Get settings from window.theme
    const showPriceOnOpticals = window.theme?.show_price_on_opticals || false;
    const seasonalBadgeTag = window.theme?.product_tag_seasonal_current || '';
    const seasonalBadgeText = window.theme?.product_badge_seasonal_current || '';
    const seasonalBadgeIcon = window.theme?.product_badge_seasonal_icon || '';
    const nextBadgeIcon = window.theme?.product_badge_next || '';
    const lowStockThreshold = window.theme?.low_stock_threshold || 10;

    console.log(lowStockThreshold, 'lowStockThreshold');
    
    // Check if product is low in stock
    const isLowStock = product.variants?.some(variant => 
      variant.inventory_quantity !== null && 
      variant.inventory_quantity > 0 && 
      variant.inventory_quantity <= lowStockThreshold
    );

    const isComingSoon = product.tags?.includes('coming-soon');

    // console.log('Product:', product);
    // console.log('Is Low Stock:', isLowStock);
    
    // Determine which badge to show (similar logic to the Liquid snippet)
    if (showPriceOnOpticals) {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (isLowStock) {
        badgeToShow = "LowStock";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    } else {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (isLowStock) {
        badgeToShow = "LowStock";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    }
    
    if (!badgeToShow) return null;
    
    // Create badge element
    const badgeElement = document.createElement('div');
    badgeElement.className = `product__badge${badgeToShow === "Next" ? " product__badge--next" : ""}${badgeToShow === "Notify" ? " product__badge--notify" : ""}${badgeToShow === "Coming Soon" ? " product__badge--notify" : ""}${badgeToShow === "LowStock" ? " product__badge--low-stock" : ""}`;
    
    let badgeHTML = '';
    
    switch (badgeToShow) {
      case "Coming Soon":
        badgeHTML = '<span class="badge badge--notify">Coming soon</span>';
        break;
      case "Notify":
        badgeHTML = '<span class="badge badge--notify">Notify me</span>';
        break;
      case "Optical":
        badgeHTML = '<span class="badge badge--optical">Optical</span>';
        break;
      case "LowStock":
        badgeHTML = '<span class="badge badge--low-stock">Low in stock</span>';
        break;
      case "Odyssey":
        if (seasonalBadgeIcon) {
          badgeHTML = `<span class="badge__icon"><img src="${seasonalBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        }
        badgeHTML += `<span class="badge badge--odyssey">${seasonalBadgeText || 'Odyssey'}</span>`;
        break;
      case "Next":
        if (nextBadgeIcon) {
          badgeHTML = `<span class="badge__icon badge__icon--next"><img src="${nextBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        } else {
          badgeHTML = '<span class="badge badge--next">KOMONO NEXT</span>';
        }
        break;
      case "Custom":
        badgeHTML = `<span class="badge badge--custom">${product.metafields.custom.badge}</span>`;
        break;
      default:
        badgeHTML = `<span class="badge">${badgeToShow}</span>`;
    }
    
    badgeElement.innerHTML = badgeHTML;
    return badgeElement;
  }
  
  // Function to search products using Shopify's predictive search API
  async function searchProducts(term) {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product`);
      const data = await response.json();
      return data.resources.results.products || [];
    } catch (error) {
      console.error('Error searching products:', error);
      return [];
    }
  }
  
  // Move load more button to the end of the products grid
  function moveLoadMoreButton() {
    if (loadMoreButton && productsGrid) {
      const buttonContainer = document.createElement('div');
      buttonContainer.className = 'search-page__item search-page__load-more-container';
      buttonContainer.appendChild(loadMoreButton);
      productsGrid.appendChild(buttonContainer);
    }
  }
  
  // Handle load more button
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      if (isLoading || !hasMoreResults) return;
      currentPage++;
      loadMoreResults();
    });
  }
  
  // Load more results via AJAX (only for products)
  function loadMoreResults() {
    if (!currentSearchTerm) return;
    
    isLoading = true;
    showLoading();
    
    // Build the next page URL - only for products
    let searchURL = `/search?q=${encodeURIComponent(currentSearchTerm)}&page=${currentPage}&type=product`;
    
    // Fetch the next page
    fetch(searchURL)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Extract new product items
        const newProductItems = doc.querySelectorAll('.search-page__product-item');
        if (newProductItems.length > 0 && productsGrid) {
          // Remove the load more button before adding new products
          const loadMoreContainer = productsGrid.querySelector('.search-page__load-more-container');
          if (loadMoreContainer) {
            productsGrid.removeChild(loadMoreContainer);
          }
          
          // Add new products
          newProductItems.forEach(item => {
            productsGrid.appendChild(item.cloneNode(true));
          });
          
          // Move the load more button to the end
          if (loadMoreButton && hasMoreResults) {
            moveLoadMoreButton();
          }
        }
        
        // Check if there are more pages
        const nextPage = currentPage + 1;
        const hasNextPage = doc.querySelector(`.search-page__pagination a[href*="page=${nextPage}"]`) !== null;
        hasMoreResults = hasNextPage && newProductItems.length > 0;
        
        if (!hasMoreResults && loadMoreButton) {
          loadMoreButton.classList.add('hidden');
        }
        
        // Initialize functionality on new items
        initializeProductCards();
        
        hideLoading();
        isLoading = false;
      })
      .catch(error => {
        console.error('Error loading more results:', error);
        hideLoading();
        isLoading = false;
      });
  }
  
  // Search for stories using Storefront API
  async function searchStories(term) {
    try {
      const graphqlQuery = {
        query: `
          query GetStoryPages($query: String!, $first: Int!) {
            pages(first: $first, query: $query) {
              edges {
                node {
                  id
                  title
                  handle
                  onlineStoreUrl
                  isLanding: metafield(namespace:"theme", key:"is_landing_page") {
                    value
                  }
                  featured: metafield(namespace:"theme", key:"landing_page_featured_image_video") {
                    value
                    reference {
                      __typename
                      ... on MediaImage { image { url } }
                      ... on GenericFile { url }
                      ... on Video { sources { url } }
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          query: term,
          first: 10
        }
      };
      
      const response = await fetch(`https://${SHOP_DOMAIN}/api/2023-10/graphql.json`, {
        method: 'POST',
        headers: {
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(graphqlQuery)
      });
      
      const data = await response.json();
      
      if (!data.data?.pages?.edges) {
        return [];
      }
      
      // Process story pages with proper image handling
      const isTrue = v => ['true', '1', true].includes(
        typeof v === 'string' ? v.toLowerCase() : v
      );
      
      return data.data.pages.edges
        .map(({ node: page }) => {
          // Filter for landing pages only
          if (!page.isLanding || !isTrue(page.isLanding.value)) {
            return null;
          }
          
          // Get featured image
          let featuredImage = null;
          
          if (page.featured) {
            if (page.featured.reference) {
              const ref = page.featured.reference;
              
              if (ref.__typename === 'MediaImage' && ref.image) {
                featuredImage = ref.image.url;
              } else if (ref.__typename === 'GenericFile') {
                featuredImage = ref.url;
              } else if (ref.__typename === 'Video' && ref.sources?.length) {
                featuredImage = ref.sources[0].url;
              }
            }
            
            // Fallback to value if no reference URL
            if (!featuredImage && page.featured.value) {
              featuredImage = page.featured.value;
            }
          }
          
          return {
            id: page.id,
            title: page.title,
            handle: page.handle,
            url: page.onlineStoreUrl || `/pages/${page.handle}`,
            featuredImage: featuredImage || '/assets/placeholder-story.jpg'
          };
        })
        .filter(page => page !== null);
    } catch (error) {
      console.error('Error searching stories:', error);
      return [];
    }
  }
  
  // Create story card
  function createStoryCard(story) {
    const storyCard = document.createElement('div');
    storyCard.className = 'search-page__item search-page__story-item';
    storyCard.setAttribute('data-handle', story.handle);
    
    storyCard.innerHTML = `
      <a href="${story.url}" class="story-card">
        <div class="story-card__image">
          <img src="${story.featuredImage}" alt="${story.title}" loading="lazy">
        </div>
        <div class="story-card__info">
          <h3 class="story-card__title h4">${story.title}</h3>
        </div>
      </a>
    `;
    
    return storyCard;
  }
  
  // Sort and organize pages and stories
  async function organizeStoriesAndPages() {
    if (!currentSearchTerm) return;
    
    try {
      // 1. Fetch stories from the API
      const stories = await searchStories(currentSearchTerm);
      
      if (stories.length === 0) return;
      
      // 2. Create a set of story handles for quick lookup
      storyHandles = new Set(stories.map(story => story.handle));
      
      // 3. Remove pages that are actually stories
      if (pagesGrid) {
        const pageItems = pagesGrid.querySelectorAll('.search-page__page-item');
        pageItems.forEach(item => {
          const link = item.querySelector('a');
          if (link) {
            const url = new URL(link.href, window.location.origin);
            const pathParts = url.pathname.split('/');
            const handle = pathParts[pathParts.length - 1];
            
            // If this page is a story, remove it from pages section
            if (storyHandles.has(handle)) {
              item.remove();
            }
          }
        });
        
        // Hide pages section if empty
        if (pagesGrid.children.length === 0) {
          const pagesSection = document.querySelector('.search-page__pages-section');
          if (pagesSection) {
            pagesSection.style.display = 'none';
          }
        }
      }
      
      // 4. Create and populate stories section
      if (storiesGrid) {
        // Clear any existing stories
        storiesGrid.innerHTML = '';
        
        // Add each story
        stories.forEach(story => {
          const storyCard = createStoryCard(story);
          storiesGrid.appendChild(storyCard);
        });
        
        // Show stories section
        const storiesSection = document.querySelector('.search-page__stories-section');
        if (storiesSection) {
          storiesSection.style.display = 'flex';
        }
      }
    } catch (error) {
      console.error('Error organizing stories and pages:', error);
    }
  }
  
  // Initialize product cards (swiper, quick-add, etc.)
  function initializeProductCards() {
    // Initialize Swiper for product galleries
    if (window.Swiper) {
      const swipers = document.querySelectorAll('.card-product__gallery.swiper:not(.swiper-initialized)');
      swipers.forEach(el => {
        new Swiper(el, {
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
          }
        });
      });
    }
    
    // Initialize quick add buttons
    if (window.initQuickAddButtons) {
      window.initQuickAddButtons(document);
    }
    
    // Initialize product favorites if exists
    if (window.initProductFavorites) {
      window.initProductFavorites(document);
    }
  }
  
  function showLoading() {
    if (loadingElement) {
      loadingElement.style.display = 'flex';
      document.querySelector('.search-page__content').setAttribute('aria-hidden', 'true');
    }
  }
  
  function hideLoading() {
    if (loadingElement) {
      loadingElement.style.display = 'none';
      document.querySelector('.search-page__content').setAttribute('aria-hidden', 'false');
    }
  }
  
  // Initialize functionality on page load
  function init() {
    // Move load more button to end of product grid
    moveLoadMoreButton();
    
    // Organize stories and pages
    organizeStoriesAndPages();
    
    // Initialize product cards for initial results
    initializeProductCards();
  }
  
  // Start initialization
  init();
});